@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Washington</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      @if (baseRules?.selectionId === "StateMinimum_VaryBetweenStates_BodilyInjuryWithMandatoryPropertyDamage") {
        <div class="axis-form-group _mt-medium">
          <label>
            {{ textValues?.Reject_BI_Coverage_LevelOne_Radio_Text }}
          </label>
        </div>
      }
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>

          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
            '_ml-xlarge': baseRules?.Show_Indent,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <div class="axis-grid">
        @for (control of controls | slice: 2; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                  >{{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  ></label
                >
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <div class="has-axis-error">
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select the {{ control.label }}.</span
                      >
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
        @if ((baseRules?.["UIMBILimitEAFIFTY_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[6].label }}</label>
              <div id="uimbilimiteafifty_50k-pdffield-washington">
                {{ controls[6].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UIMBIEPEAFIXED_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[7].label }}</label>
              <div id="uimbiepeafixed_25k_50k-pdffield-washington">
                {{ controls[7].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UIMPDEATEN_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[8].label }}</label>
              <div id="uimpdeaten_10k-pdffield-washington">
                {{ controls[8].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["UIMBIPDSIXTY_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div id="uimbipdsixty_60k-pdffield-washington">
                {{ controls[9].data[0].name }}
              </div>
            </div>
          </div>
        }

        @if ((baseRules?.["REJECTUIMBIEPEATWENTYFIVEFIFTY_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[10].label }}</label>
              <div id="rejectuimbiepeatwentyfivefifty_25k_50k-pdffield-washington">
                {{ controls[10].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>
    </form>
  }
}
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Washington</h2>
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label"> {{ textValues?.Reject_Text }} </label>
    </div>
  }

  <div class="axis-grid">
    @if (baseRules && baseRules?.UIMBILimitEAFIFTY_DropDown) {
      <div class="axis-col-sm-12 axis-col-lg-12">
        <div class="axis-form-group _mt-medium">
          <label>
            {{ textValues?.Reject_BI_Coverage_LevelOne_Radio_Text }}
          </label>
        </div>
      </div>
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[6].label }} </label>
          <div>{{ controls[6].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules && baseRules?.UIMBIEPEAFIXED_DropDown) {
      <div class="axis-col-sm-12 axis-col-lg-12">
        <div class="axis-form-group _mt-medium">
          <label>
            {{ textValues?.Reject_BI_Coverage_LevelOne_Radio_Text }}
          </label>
        </div>
      </div>
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[7].label }} </label>
          <div>{{ controls[7].data[0].name }}</div>
        </div>
      </div>
    }
    @if (baseRules && baseRules?.REJECTUIMBIEPEATWENTYFIVEFIFTY_DropDown) {
      <div class="axis-col-sm-12 axis-col-lg-12">
        <div class="axis-form-group _mt-medium">
          <label>
            {{ textValues?.Reject_BI_Coverage_LevelOne_Radio_Text }}
          </label>
        </div>
      </div>
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[10].label }} </label>
          <div>{{ controls[10].data[0].name }}</div>
        </div>
      </div>
    }
    @if(baseRules && baseRules?.UM_LiabilityLimit_DropDown) {
      <div class="axis-col-sm-12 axis-col-lg-12">
        <div class="axis-form-group _mt-medium">
          <label>
            {{ textValues?.Reject_BI_Coverage_LevelOne_Radio_Text }}
          </label>
        </div>
      </div>
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[12].label }} </label>
          <div>{{ controls[12].data[0].name }}</div>
        </div>
      </div>
    }
    @if(baseRules && baseRules?.UIM_LiabilityLimit_DropDown) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[13].label }} </label>
          <div>{{ controls[13].data[0].name }}</div>
        </div>
      </div>
    }

  </div>
}
